export const richContentSelect = `
.dropdown-container {
  position: relative;
  box-sizing: border-box;
  cursor: pointer;
  font-style: inherit;
  font-variant: inherit;
  font-weight: inherit;
  font-stretch: inherit;
  line-height: inherit;
  font-family: inherit;
  font-optical-sizing: inherit;
  font-size-adjust: inherit;
  font-kerning: inherit;
  font-feature-settings: inherit;
  font-variation-settings: inherit;
  font-size: 14px;
}
.dropdown-container *[class*="a11yText"] {  
  z-index: 9999;
  border: 0px;
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  width: 1px;
  position: absolute;
  overflow: hidden;
  padding: 0px;
  white-space: nowrap;
}
.chat-dropdown__control {
  -webkit-box-align: center;
  align-items: center;
  cursor: default;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  justify-content: space-between;
  min-height: 30px;
  position: relative;
  transition: box-shadow 0.2s, border-color 0.2s;
  border-radius: 0px;
  box-shadow: rgb(202, 202, 202) 0px -1px 0px 0px inset;
  box-sizing: border-box;
  border: 0px;
  min-width: 150px;
  width: 100%;
  padding: 0px;
  outline: 0px !important;
}
.chat-dropdown__control:hover {
  border-color: rgb(179, 179, 179);
}
.chat-dropdown__control:hover,
.chat-dropdown__control:focus {
  box-shadow: rgb(114, 114, 114) 0px -2px 0px 0px inset;
}
.chat-dropdown__value-container {
  -webkit-box-align: center;
  align-items: center;
  display: grid;
  flex: 1 1 0%;
  flex-wrap: wrap;
  position: relative;
  overflow: hidden;
  padding: 0px;
  box-sizing: border-box;
  color: rgb(40, 41, 41);
}
.chat-dropdown__single-value {
  grid-area: 1 / 1 / 2 / 3;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: rgb(40, 41, 41);
  margin-left: 0px;
  margin-right: 2px;
  box-sizing: border-box;
  padding-top: 2px;
  transform: unset;
  top: 0px;
}
.chat-dropdown__input-container {
  visibility: visible;
  flex: 1 1 auto;
  display: inline-grid;
  grid-area: 1 / 1 / 2 / 3;
  grid-template-columns: 0px min-content;
  margin: 0px;
  padding-bottom: 7px;
  padding-top: 2px;
  color: rgb(51, 51, 51);
  box-sizing: border-box;
  line-height: 18px;
  z-index: 1;
}
.chat-dropdown__input-container::after {
  content: attr(data-value) ' ';
  visibility: hidden;
  white-space: pre;
  grid-area: 1 / 2;
  font: inherit;
  min-width: 2px;
  border: 0px;
  margin: 0px;
  outline: 0px;
  padding: 0px;
}
.chat-dropdown__indicators {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-shrink: 0;
  box-sizing: border-box;
}
.chat-dropdown__indicator-separator {
  display: none;
}
.chat-dropdown__indicator .chat-dropdown__dropdown-indicator {
  display: flex;
  transition: color 150ms;
  color: rgb(202, 202, 202);
  padding: 0px;
  box-sizing: border-box;
}
.chat-dropdown__dropdown-indicator:hover {
  color: rgb(153, 153, 153);
}
.chat-dropdown__placeholder {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  grid-area: 1 / 1 / 2 / 3;
  color: rgb(114, 114, 114);
  margin-left: 2px;
  margin-right: 2px;
  box-sizing: border-box;
  padding-top: 2px;
  padding-bottom: 7px;
  position: absolute;
  transform: unset;
  top: 0px;
}
.chat-dropdown__control--menu-is-open {
  -webkit-box-align: center;
  align-items: center;
  cursor: default;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  justify-content: space-between;
  min-height: 30px;
  position: relative;
  transition: box-shadow 0.2s, border-color 0.2s;
  border-radius: 0px;
  box-shadow: rgb(0, 112, 247) 0px -1px 0px 0px inset;
  box-sizing: border-box;
  border-image: initial;
  border-width: 0px;
  border-style: initial;
  min-width: 150px;
  width: 100%;
  padding: 0px;
  outline: 0px !important;
  border-color: rgb(0, 112, 247) !important;
}
.chat-dropdown__control--menu-is-open:hover {
  border-color: rgb(0, 112, 247) !important;
}
.chat-dropdown__control--menu-is-open:hover,
.chat-dropdown__control--menu-is-open:focus {
  box-shadow: rgb(0, 112, 247) 0px -2px 0px 0px inset;
}
.chat-dropdown__clear-indicator {
  display: flex;
  transition: color 150ms;
  color: rgb(102, 102, 102);
  padding: 0px;
  box-sizing: border-box;
  cursor: pointer;
  margin-right: 1px;
  border-top: 1px solid transparent;
  border-right: 1px solid rgb(213, 213, 213);
}
.chat-dropdown__clear-indicator:hover {
  color: rgb(51, 51, 51);
}
.chat-dropdown__dropdown-indicator {
  display: flex;
  transition: color 150ms;
  color: rgb(102, 102, 102);
  padding: 0px;
  box-sizing: border-box;
}
.chat-dropdown__dropdown-indicator:hover {
  color: rgb(51, 51, 51);
}
.chat-dropdown__menu {
  top: 100%;
  position: absolute;
  width: calc(100% + 16px);
  z-index: 2;
  background-color: rgb(255, 255, 255);
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.15) 5px 10px 20px 0px;
  margin-bottom: 8px;
  margin-top: 2px;
  box-sizing: border-box;
  border: 1px solid rgb(225, 225, 225);
  padding-bottom: 9px;
  padding-top: 9px;
  right: -8px;
  min-width: calc(166px);
}
.chat-dropdown__menu-list {
  max-height: 165px;
  overflow-y: auto;
  position: relative;
  box-sizing: border-box;
  padding: 0px;
}
// .css-350sy3-control {
//   -webkit-box-align: center;
//   align-items: center;
//   cursor: default;
//   display: flex;
//   flex-wrap: wrap;
//   -webkit-box-pack: justify;
//   justify-content: space-between;
//   min-height: 30px;
//   position: relative;
//   transition: box-shadow 0.2s, border-color 0.2s;
//   border-radius: 0px;
//   box-sizing: border-box;
//   border-image: initial;
//   border-width: 0px;
//   border-style: initial;
//   min-width: 150px;
//   width: 100%;
//   padding: 0px;
//   outline: 0px !important;
//   border-color: rgb(0, 112, 247) !important;
//   box-shadow: rgb(0, 112, 247) 0px -1px 0px 0px inset !important;
// }
// .css-350sy3-control:hover {
//   border-color: rgb(0, 112, 247) !important;
// }
// .css-350sy3-control:hover,
// .css-350sy3-control:focus {
//   box-shadow: rgb(0, 112, 247) 0px -2px 0px 0px inset;
// }
// .css-b6okis {
//   visibility: visible;
//   transform: translateZ(0px);
//   flex: 1 1 auto;
//   display: inline-grid;
//   grid-area: 1 / 1 / 2 / 3;
//   grid-template-columns: 0px min-content;
//   margin: 0px;
//   padding-bottom: 7px;
//   padding-top: 2px;
//   color: rgb(51, 51, 51);
//   box-sizing: border-box;
//   line-height: 18px;
//   z-index: 1;
// }
// .css-b6okis::after {
//   content: attr(data-value) ' ';
//   visibility: hidden;
//   white-space: pre;
//   grid-area: 1 / 2;
//   font: inherit;
//   min-width: 2px;
//   border: 0px;
//   margin: 0px;
//   outline: 0px;
//   padding: 0px;
// }
.chat-dropdown__menu-notice {
  text-align: center;
  color: rgb(153, 153, 153);
  padding: 8px 12px;
  box-sizing: border-box;
}
.chat-dropdown__option--is-selected {
  cursor: pointer;
  display: block;
  font-size: inherit;
  width: 100%;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  color: rgb(255, 255, 255);
  padding: 7px 17px;
  box-sizing: border-box;
  background-color: rgb(0, 112, 247) !important;
}

.chat-dropdown__option--is-selected > div {
  color: rgb(255, 255, 255);
}

.chat-dropdown__option--is-selected:active {
  background-color: rgb(0, 112, 247) !important;
}
.chat-dropdown__option--is-selected mark {
  color: rgb(255, 255, 255);
}
.chat-dropdown__option {
  cursor: pointer;
  display: block;
  font-size: inherit;
  width: 100%;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  background-color: transparent;
  color: rgb(40, 41, 41);
  padding: 7px 17px;
  box-sizing: border-box;
}
.chat-dropdown__option:active {
  background-color: rgb(230, 241, 255);
}
.chat-dropdown__option mark {
  color: rgb(40, 41, 41);
}
.chat-dropdown__option--is-focused {
  cursor: pointer;
  display: block;
  font-size: inherit;
  width: 100%;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  background-color: rgb(230, 241, 255);
  color: rgb(40, 41, 41);
  padding: 7px 17px;
  box-sizing: border-box;
}
.chat-dropdown__option--is-focused:active {
  background-color: rgb(230, 241, 255);
}
.chat-dropdown__option--is-focused mark {
  color: rgb(40, 41, 41);
}
`;

export const welcomeFormSelect = `
.dform-container {
  position: relative;
  box-sizing: border-box;
  cursor: pointer;
  font-style: inherit;
  font-variant: inherit;
  font-weight: inherit;
  font-stretch: inherit;
  line-height: inherit;
  font-family: inherit;
  font-optical-sizing: inherit;
  font-size-adjust: inherit;
  font-kerning: inherit;
  font-feature-settings: inherit;
  font-variation-settings: inherit;
  font-size: 14px;
}
.dform-container *[class*="a11yText"] {
  z-index: 9999;
  border: 0px;
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  width: 1px;
  position: absolute;
  overflow: hidden;
  padding: 0px;
  white-space: nowrap;
}
.dform-dropdown__control {
  -webkit-box-align: center;
  align-items: center;
  cursor: default;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  justify-content: space-between;
  min-height: 30px;
  position: relative;
  transition: box-shadow 0.2s, border-color 0.2s;
  border-radius: 0px;
  box-shadow: rgb(202, 202, 202) 0px -1px 0px 0px inset;
  box-sizing: border-box;
  border: 0px;
  min-width: 150px;
  width: 100%;
  padding: 0px;
  outline: 0px !important;
}
.dform-dropdown__control:hover {
  border-color: rgb(179, 179, 179);
}
.dform-dropdown__control:hover,
.dform-dropdown__control:focus {
  box-shadow: rgb(114, 114, 114) 0px -2px 0px 0px inset;
}
.dform-dropdown__value-container {
  -webkit-box-align: center;
  align-items: center;
  display: grid;
  flex: 1 1 0%;
  flex-wrap: wrap;
  position: relative;
  overflow: hidden;
  padding: 0px;
  box-sizing: border-box;
  color: rgb(40, 41, 41);
}
.dform-dropdown__single-value {
  grid-area: 1 / 1 / 2 / 3;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: rgb(40, 41, 41);
  margin-left: 0px;
  margin-right: 2px;
  box-sizing: border-box;
  padding-top: 2px;
  transform: unset;
  top: 0px;
}
.dform-dropdown__input-container {
  visibility: visible;
  flex: 1 1 auto;
  display: inline-grid;
  grid-area: 1 / 1 / 2 / 3;
  grid-template-columns: 0px min-content;
  margin: 0px;
  padding-bottom: 7px;
  padding-top: 2px;
  color: rgb(51, 51, 51);
  box-sizing: border-box;
  line-height: 18px;
  z-index: 1;
}
.dform-dropdown__input-container::after {
  content: attr(data-value) ' ';
  visibility: hidden;
  white-space: pre;
  grid-area: 1 / 2;
  font: inherit;
  min-width: 2px;
  border: 0px;
  margin: 0px;
  outline: 0px;
  padding: 0px;
}
.dform-dropdown__indicators {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-shrink: 0;
  box-sizing: border-box;
}
.dform-dropdown__indicator-separator {
  display: none;
}
.dform-dropdown__dropdown-indicator {
  display: flex;
  transition: color 150ms;
  color: rgb(202, 202, 202);
  padding: 0px;
  box-sizing: border-box;
}
.dform-dropdown__dropdown-indicator:hover {
  color: rgb(153, 153, 153);
}
.dform-dropdown__control {
  -webkit-box-align: center;
  align-items: center;
  cursor: default;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  justify-content: space-between;
  min-height: 30px;
  position: relative;
  transition: box-shadow 0.2s, border-color 0.2s;
  border-radius: 0px;
  box-shadow: rgb(0, 112, 247) 0px -1px 0px 0px inset;
  box-sizing: border-box;
  border-image: initial;
  border-width: 0px;
  border-style: initial;
  min-width: 150px;
  width: 100%;
  padding: 0px;
  outline: 0px !important;
  border-color: rgb(0, 112, 247) !important;
}
.dform-dropdown__control:hover {
  border-color: rgb(0, 112, 247) !important;
}
.dform-dropdown__control:hover,
.dform-dropdown__control:focus {
  box-shadow: rgb(0, 112, 247) 0px -2px 0px 0px inset;
}
.dform-dropdown__dropdown-indicator {
  display: flex;
  transition: color 150ms;
  color: rgb(102, 102, 102);
  padding: 0px;
  box-sizing: border-box;
}
.dform-dropdown__dropdown-indicator:hover {
  color: rgb(51, 51, 51);
}
.dform-dropdown__menu {
  top: 100%;
  position: absolute;
  width: calc(100% + 16px);
  z-index: 2;
  background-color: rgb(255, 255, 255);
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.15) 5px 10px 20px 0px;
  margin-bottom: 8px;
  margin-top: 2px;
  box-sizing: border-box;
  border: 1px solid rgb(225, 225, 225);
  padding: 9px;
  right: -8px;
  min-width: calc(166px);
}
.dform-dropdown__menu-list10khhaz {
  max-height: 165px;
  overflow-y: auto;
  position: relative;
  box-sizing: border-box;
  padding: 0px;
}
.dform-dropdown__option--is-selected {
  cursor: pointer;
  display: block;
  font-size: inherit;
  width: 100%;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  color: rgb(255, 255, 255);
  padding: 7px 17px;
  box-sizing: border-box;
  background-color: rgb(0, 112, 247) !important;
}

.dform-dropdown__option--is-selected > span {
  color: rgb(255, 255, 255);
}

.dform-dropdown__option--is-selected:active {
  background-color: rgb(0, 112, 247) !important;
}
.dform-dropdown__option--is-selected mark {
  color: rgb(255, 255, 255);
}
.dform-dropdown__option {
  cursor: pointer;
  display: block;
  font-size: inherit;
  width: 100%;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  background-color: transparent;
  color: rgb(40, 41, 41);
  padding: 7px 17px;
  box-sizing: border-box;
}
.dform-dropdown__option:active {
  background-color: rgb(230, 241, 255);
}
.dform-dropdown__option mark {
  color: rgb(40, 41, 41);
}
.css-11ms268-option {
  cursor: pointer;
  display: block;
  font-size: inherit;
  width: 100%;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  background-color: rgb(230, 241, 255);
  color: rgb(40, 41, 41);
  padding: 7px 17px;
  box-sizing: border-box;
}
.css-11ms268-option:active {
  background-color: rgb(230, 241, 255);
}
.css-11ms268-option mark {
  color: rgb(40, 41, 41);
}
`;
